import React from "react";
import CircleSVG from "@/assets/icons-js/circle";
import { useStateContext } from "@/components/state";
import NonSsrWrapper from "@/components/wrappers/non-ssr-wrapper";

const Header = ({ children }) => {
    const { state } = useStateContext();

    return (
        <NonSsrWrapper>
            <div className="section__header mb-12 sm-hidden--hard">
                <span>Steg { (state?.scenes?.current ?? 1).toString().padStart(2, "0") }</span>
                <div>
                    { children }
                </div>
                <span>
                    <CircleSVG progress={((state?.scenes?.current ?? 1) / (state?.scenes?.total ?? 1)) * 100}/>
                </span>
            </div>

            <div className="section__header mb-4 md-hidden--hard lg-hidden--hard">
                <span>Steg { (state?.scenes?.current ?? 1).toString().padStart(2, "0") }</span>
                <span>
                    <CircleSVG progress={((state?.scenes?.current ?? 1) / (state?.scenes?.total ?? 1)) * 100}/>
                </span>
                <div className="mt-3">
                    { children }
                </div>
            </div>
        </NonSsrWrapper>
    );
};

export default Header;
